import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PROJECTS_FEATURE_KEY, ProjectsState, projectsAdapter } from './projects.reducer';

// Lookup the 'Projects' feature state managed by NgRx
export const selectProjectsState = createFeatureSelector<ProjectsState>(PROJECTS_FEATURE_KEY);

const { selectAll, selectEntities } = projectsAdapter.getSelectors();

export const GetMyAllProjectsList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.myAllProjectsList
);
export const GetMyAllProductProjectsList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.myAllProductProjectsList
);

export const GetDefalutMaterialProjectList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.newDefalutMaterialList
);

export const GetMyAllProjectsScenarioList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.myAllProjectsScenarioList
);

export const GetMyAllProjectsPackMaterialList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.myAllProjectsPackMaterialList
);

export const GetmyAllProjectsPackConversionList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.myAllProjectsPackConversionList
);

export const GetMyAllProjectsScenarioConsumerList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.myAllProjectsScenarioConsumerList
);

export const GetMyAllProjectsScenarioReatilList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.myAllProjectsScenarioReatilList
);

export const GetMyAllProjectsScenarioWholesaleList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.myAllProjectsScenarioWholesaleList
);

//For Add-Edit Transport Scenario
export const GetTransportScenarioListForPackMaterial = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.transportScenarioList
);

export const GetTransportScenarioListFordistance = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.transportScenarioListForDistance
);
export const GetCustomTransoportScenarioDetailViewModels = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.customTransoportScenarioDetailViewModels
);
export const GetProjectPackConversionList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.conversionList
);

export const GetProjectFillingList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.fillingList
);

export const GetFillingProcessList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.fillingProcessList
);
//pack retail
export const GetTransportScenarioEolDataListForRetail = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.transportScenarioEolDataListForRetail
);
export const GetTransportScenarioListForRetail = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.transportScenarioListForRetail
);
export const GetTransportScenarioListForDistancePackRetail = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.transportScenarioListForDistancePackRetail
);

export const GetLocationList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.locationList
);

export const GetDistanceList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.distanceList
);

export const GetLocationProductList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.locationListProduct
);

export const GetDistanceProductList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.distanceProductList
);

export const GetFreightList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.freightList
);

export const GetFreightProductList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.freightProductList
);

export const GetComponentTransport = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.componentList
);
export const GetProductTransport = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.productList
);

export const GetresetEolList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.resetEolList
);
export const GetEolTotalError = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.eolTotalError
);

export const GetProjectWholesaleList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.wholesaleList
);

export const GetWholesaleLocationList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.locationWholesaleList
);

export const GetWholesaleDistanceList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.distanceWholesaleList
);

export const GetFreightWholesaleList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.freightWholesaleList
);

export const showErrorMsgProject = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.errorMsgForComponent
);

export const showReuseEOLErr = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.errorMsgForReuseEOL
);

// for filling
export const GetReplicaLocationList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.replicaLocation
);

export const GetReplicaDistanceList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.replicaDistance
);

export const GetProductIngredient = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.productIngredientList
);

export const getIngredientItems = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.ingredientItems
);

export const organizationItemsSelector = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.organizationItems
);

export const organizationPreferencesItemsSelector = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.organizationPreferencesItems
);

export const getIngredientTransportItems = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.ingredientTransportList
);

export const storeerr = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.storeerr
);

export const getManufacturProcess = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.getManufacturProcessList
);

export const errorMessageForProductIngredient = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.errorMessageForProductIngredient
);

export const ProductManufactureList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.productManufactureList
);

export const productIngredientDistance = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.porductIngredientDistance
);

export const productIngredientistanceProcessList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.productIngredientistanceProcessList
);
export const projectName = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.projectName
);
export const GetList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.newDefalutMaterialList
);

export const GetDefalutOrgReportingList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.newDefalutOrgReportingList
);
export const GetEolResueList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.eolResueList
);

export const GetEolConsumerList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.eolConsumerList
);

// transport pre retail
export const getEolPreRetailData = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.eolPreRetailData
);
export const getTransportScenarioManudalLocationList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.transportScenarioManualLocationList
);
export const getTransportScenarioManualDistanceList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.transportScenarioManualDistanceList
);
export const getComponentPreRetailList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.componentPreRetailList
);
export const getPreRetailReuseActionList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.preRetailReuseActionList
);
export const duplicateManualLocation = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.duplicateManualLocation
);
export const duplicateManualDistance = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.duplicateManualDistance
);
export const dupliatePreRetailActionList = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.dupliatePreRetailActionList
);

export const orgReportingErrorSelector = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.orgReportingErrorState
);

export const packEOLRetail = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.packEOLRetailList
);

export const packEOLConsumer = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.packEOLConsumerList
);

export const productMixData = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.productMixProcess
);

export const productMixError = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.productMixProcessError
);
export const distanceErrorProject = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.distanceErrorProject
);
export const distanceErrorProjectProduct = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.distanceErrorProjectProduct
);

export const checkProdMixSelector = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.checkUpdateActionProdMix
);
export const checkUpdateActionForOrganizationSelector = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.checkUpdateActionForOrganizationMapping
);
export const checkUpdateActionInterpretation = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.checkUpdateActionInterpretation
);
export const checkUpdateActionIngredient = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.checkUpdateActionIngredient
);

export const updateTechnology = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.dataAnalysisTechnology
);

export const checkUpdateActionForReuseSelector = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.checkUpdateActionForReuse
);
